<section class="map-sidebar-items">
    @if (displayAsList) {
        <div>
            @for (mapItem of mapItems; track mapItem.uniqueId) {
                <ui-map-sidebar-list-item
                    [mapItem]="mapItem"
                    [customContentComponentType]="listCustomContentComponentType"
                    (mapItemClicked)="onMapItemClicked($event)"
                />
            }
        </div>
    } @else {
        <div class="map-sidebar-items__raster">
            @for (mapItem of mapItems; track mapItem.uniqueId) {
                <ui-map-sidebar-raster-item
                    [mapItem]="mapItem"
                    [gridContentComponentType]="gridContentComponentType"
                    (mapItemClicked)="onMapItemClicked($event)"
                />
            }
        </div>
    }
</section>
